"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _TimeConflictModel = _interopRequireDefault(require("../components/TimeConflictModel.vue"));
/**
 * 时间冲突弹窗mixins
 */
/** components */
var _default = exports.default = {
  components: {
    TimeConflictModel: _TimeConflictModel.default
  },
  methods: {
    // 时间冲突处理
    timeConflitHandle: function timeConflitHandle(errorInfos, conflitParams) {
      var _this = this;
      var errArr = errorInfos || [];
      errArr.some(function (i) {
        var hasConflit = ['PlanTask_actual_time_conflicts', 'PlanTask_plan_time_conflicts'].indexOf(i.key) >= 0;
        if (hasConflit) {
          _this.$refs['timeConflictModel'].init(conflitParams);
        }
        return hasConflit;
      });
    }
  }
};